import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store/index";
import LocalDataService from "@/service/LocalDataService";
import ApiAiReport, {
  AiReportTopResponse,
  AiReportBatchResponse,
  AiReportQuarter,
} from "@/api/ApiAiReport";

export interface AiReportTopState {
  top: AiReportTopResponse | null;
  isFetching: boolean;
  activeBatch: AiReportBatchResponse | null;
}

@(Module({ dynamic: true, store, name: "ai-report-top", namespaced: true }) as unknown as (target: new (...args: unknown[]) => VuexModule) => void)
class AiReportTopModule extends VuexModule implements AiReportTopState {
  top: AiReportTopResponse | null = null;
  isFetching = false;
  activeBatch: AiReportBatchResponse | null = null;

  @Mutation
  setTop(top: AiReportTopResponse | null) {
    this.top = top;
  }

  @Mutation
  setFetching(value: boolean) {
    this.isFetching = value;
  }

  @Mutation
  setActiveBatch(batch: AiReportBatchResponse | null) {
    this.activeBatch = batch;
  }

  @Action
  async loadTop({ businessYear }: { businessYear: number }) {
    const nurseryId = LocalDataService.getNurseryId();
    if (!nurseryId) return;
    this.setFetching(true);
    try {
      const response = await ApiAiReport.getTop({ nurseryId, businessYear });
      this.setTop(response);
    } finally {
      this.setFetching(false);
    }
  }

  @Action
  async startBulkGenerate({
    businessYear,
    quarter,
  }: {
    businessYear: number;
    quarter: AiReportQuarter;
  }) {
    const nurseryId = LocalDataService.getNurseryId();
    if (!nurseryId) return null;
    const batch = await ApiAiReport.bulkGenerate({
      nurseryId,
      businessYear,
      quarter,
    });
    this.setActiveBatch(batch);
    return batch;
  }

  @Action
  async pollBatch({ batchId }: { batchId: number }) {
    const nurseryId = LocalDataService.getNurseryId();
    if (!nurseryId) return null;
    const batch = await ApiAiReport.getBatch({ nurseryId, batchId });
    this.setActiveBatch(batch);
    return batch;
  }
}

export const aiReportTopModule = getModule(AiReportTopModule);
